import { render, staticRenderFns } from "./Clientes.vue?vue&type=template&id=ad4f5cf8&scoped=true"
import script from "./Clientes.vue?vue&type=script&lang=js"
export * from "./Clientes.vue?vue&type=script&lang=js"
import style0 from "./Clientes.vue?vue&type=style&index=0&id=ad4f5cf8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad4f5cf8",
  null
  
)

export default component.exports